import s from './index.module.scss';

export const Toggle = ({ checked, onChange }) => {
  return (
    <label className={s.switch}>
      <input
        type="checkbox"
        className={s.input}
        checked={checked}
        onChange={() => onChange(!checked)}
      />
      <span className={s.slider} />
    </label>
  );
};
